<template>
	<v-date-picker v-bind="$attrs"
				   v-on="$listeners"
				   :first-day-of-week="startDayOfWeek">
		<slot />
	</v-date-picker>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch, Emit } from "vue-property-decorator";

@Component
export default class DatePicker extends Vue {
	@Prop({ type: Number, default: null }) firstDayOfWeek: number;

	get startDayOfWeek() {
		return this.firstDayOfWeek == null
			? this.$vopsui.options.startDayOfWeek()
			: this.firstDayOfWeek;
	}
}
</script>